import qs from 'querystring'
import request from '@/utils/request'
import { API_PREFIX } from '@/utils/constants'

/**
 * @api /api/v1.Login/login
 * @method POST
 * @description 通过账号密码登录
 *
 * @param {string} username
 * @param {string} password
 *
 */
export async function login(params) {
  try {
    const query = {
      username: params.login,
      pwd: params.password,
    }
    const res = await request.post(`${API_PREFIX}/api/v1.Login/login`, query)
    return res.data.project
  } catch (e) {
    return null
  }
}

/**
 * @api /api/v1.Sms/sendSms
 * @method POST
 * @description 向手机发送验证码
 *
 * @param {string} mobile 手机号
 *
 */
export async function sendVerificationCode(params) {
  try {
    const query = {
      mobile: params.mobilePhone,
    }
    await request.post(`${API_PREFIX}/api/v1.Sms/sendSms`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Register/register
 * @method POST
 * @description 用户注册
 *
 * @param {string} name 姓名
 * @param {string} pwd 密码
 * @param {string} mobile 手机号
 * @param {string} captcha 手机验证码
 * @param {string} code 微信 unionId
 *
 */
export async function register(params) {
  try {
    const query = {
      name: params.name,
      pwd: params.password,
      mobile: params.mobilePhone,
      captcha: params.verificationCode,
      code: params.unionId,
    }
    const res = await request.post(`${API_PREFIX}/api/v1.Register/register`, query)
    return res.data.project
  } catch (e) {
    return null
  }
}

/**
 * @api /api/v1.User/getUserInfo
 * @method GET
 * @description 获取用户信息
 *
 */
export async function getUserInfo() {
  try {
    const res = await request.get(`${API_PREFIX}/api/v1.User/getUserInfo`)
    return res.data
  } catch (e) {
    return null
  }
}

/**
 * @api /api/v1.Login/loginByMobile
 * @method POST
 * @description 通过手机验证码登录
 *
 * @param {string} mobile 手机号码
 * @param {string} captcha 验证码
 *
 */
export async function loginByCode(params) {
  try {
    const query = {
      mobile: params.mobilePhone,
      captcha: params.code,
    }
    const res = await request.post(`${API_PREFIX}/api/v1.Login/loginByMobile`, query)
    return res.data.project
  } catch (e) {
    return null
  }
}

/**
 * @api /api/v1.Login/forgetPwd
 * @method POST
 * @description 忘记密码
 *
 * @param {string} mobile 手机号码
 * @param {string} captcha 验证码
 * @param {string} new_pwd 新密码
 *
 */
export async function resetPassword(params) {
  try {
    const query = {
      mobile: params.mobilePhone,
      captcha: params.code,
      new_pwd: params.password,
    }
    await request.post(`${API_PREFIX}/api/v1.Login/forgetPwd`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Register/checkUserNameIsExist
 * @method GET
 * @description 判断手机号码是否已注册
 *
 * @param {string} username 手机号码
 *
 */
export async function loginAvailable(params) {
  try {
    const query = {
      username: params.login,
    }
    const qstr = qs.stringify(query)
    const res = await request(`${API_PREFIX}/api/v1.Register/checkUserNameIsExist?${qstr}`)
    return res.data
  } catch (e) {
    return null
  }
}

/**
 * @api /api/v1.User/setProject
 * @method POST
 * @description 切换当前项目
 *
 * @param {number} project_id 项目 ID
 *
 */
export async function changeProject(params) {
  try {
    const query = {
      project_id: params.id,
    }
    await request.post(`${API_PREFIX}/api/v1.User/setProject`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.User/getUserProjectList
 * @method GET
 * @description 获取所有可选项目
 */
export async function findAvailableProjects() {
  try {
    const res = await request.get(`${API_PREFIX}/api/v1.User/getUserProjectList`)
    return res.data
  } catch (e) {
    return []
  }
}
